import { UserPaymentIcon } from "../icons";
import Edit from "./Edit";
import List from "./List";

export default {
  options: {
    group: "dashboard",
    roles: ["user", "admin"],
    excludeRoles: ["affiliate_manager"],
  },
  list: List,
  edit: Edit,
  icon: UserPaymentIcon,
};
